class QuickAddButton extends HTMLElement {
  constructor() {
    super();

    const variants = Array.from(this.querySelectorAll('[js-variant]'));
    if (this.hasAttribute('js-variant')) {
      variants.push(this);
    }

    for (const variant of variants) {
      variant.addEventListener('click', (e) => {
        variant.classList.add('loading');
        variant.disabled = true;
        Cart.addItemToCart(variant.dataset.variantId).then(() => {
          variant.classList.remove('loading');
          variant.disabled = false;
          Cart.openCartDrawer();
        });
      });
    }
  }
}

if (!customElements.get('quick-add-button')) {
  customElements.define('quick-add-button', QuickAddButton);
}
